module.exports = __webpack_public_path__ + "be7eced1ad0196de4c85596409a14f80.svg";